import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

function LoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <p className="text-muted-foreground">Laster...</p>
    </div>
  )
}

export function PublicRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()

  if (loading) {
    return <LoadingFallback />
  }

  if (user) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
